import { useCallback, useEffect, useState } from 'react';
import { useApp } from '../lib/AppContext';

// Nấu chung's state for the signed-in account: { pair, invite, banner } from GET /cooking_pair. Null while
// loading, and on a share link or a coach's view of a student (nothing to show there).
export default function usePair() {
  const { api, editable } = useApp();
  const [state, setState] = useState(null);
  // `editable` is only true on your own log (not a share link or a coach's view of a student).
  const enabled = editable;
  const reload = useCallback(() => (enabled ? api.get('/cooking_pair').then(setState).catch(() => {}) : Promise.resolve()), [api, enabled]);
  useEffect(() => { reload(); }, [reload]);
  return [state, setState, reload];
}

export const MEALS = ['breakfast', 'lunch', 'dinner'];
export const MEAL_NAMES = { breakfast: 'Sáng', lunch: 'Trưa', dinner: 'Tối' };
export const DAYS = ['T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'CN'];
export const ALL_SLOTS = DAYS.flatMap((_, i) => MEALS.map((m) => `${i + 1}:${m}`));
export const PRESETS = [
  { id: 'dinners', label: 'Chỉ bữa tối', slots: DAYS.map((_, i) => `${i + 1}:dinner`) },
  { id: 'default', label: 'Tối + cuối tuần', slots: [1, 2, 3, 4, 5].map((d) => `${d}:dinner`).concat([6, 7].flatMap((d) => MEALS.map((m) => `${d}:${m}`))) },
  { id: 'all', label: 'Tất cả', slots: ALL_SLOTS },
];

// The avoid list as one line: "Linh không ăn tôm, hành sống".
export const avoidLine = (people) => people.filter((p) => p.avoid_foods?.length)
  .map((p) => `${p.name} không ăn ${p.avoid_foods.join(', ').toLowerCase()}`).join(' · ');
